<template>
  <div class="my-certificates">
    <div class="section-header">
      <div class="section-title">我的证书</div>
    </div>

    <div v-loading="loading" class="certificates-grid">
      <el-card
        v-for="cert in certificates"
        :key="cert.id"
        class="certificate-card"
        shadow="hover"
        :body-style="{ padding: '16px' }"
      >
        <div class="certificate-name">{{ cert.name }}</div>
        <div class="certificate-meta">
          <div class="meta-row">
            <span class="meta-label">证书编号：</span>
            <span class="meta-value">{{ cert.number }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">颁发时间：</span>
            <span class="meta-value">{{ cert.issueTime }}</span>
          </div>
        </div>
      </el-card>

      <div v-if="!loading && certificates.length === 0" class="no-certificates">
        <el-empty description="暂无证书" />
      </div>
    </div>
  </div>
</template>

<script>
import { getMyCertificates } from '@/api/authApi'

export default {
  name: 'MyCertificates',
  created() {
    this.loadCertificates()
  },
  data() {
    return {
      loading: false,
      certificates: []
    }
  },
  methods: {
    extractList(data) {
      if (Array.isArray(data)) return data
      if (!data) return []
      if (Array.isArray(data.list)) return data.list
      if (Array.isArray(data.records)) return data.records
      if (Array.isArray(data.items)) return data.items
      return []
    },
    normalizeCertificate(item, index) {
      const raw = item || {}
      const id = raw.id ?? raw.certificateId ?? raw.certificate_id ?? index

      const name =
        raw.certificateName ??
        raw.name ??
        raw.title ??
        raw.certificateTitle ??
        '证书'

      const number =
        raw.certificateNo ??
        raw.certificateNumber ??
        raw.number ??
        raw.no ??
        ''

      const issueTime =
        raw.issueTime ??
        raw.issuedAt ??
        raw.createTime ??
        raw.createdAt ??
        raw.grantTime ??
        ''

      return {
        id,
        name: String(name || ''),
        number: String(number || ''),
        issueTime: String(issueTime || ''),
        raw
      }
    },
    async loadCertificates() {
      if (this.loading) return
      this.loading = true
      try {
        const res = await getMyCertificates()
        const list = this.extractList(res && res.data)
        this.certificates = list.map((item, index) => this.normalizeCertificate(item, index))
      } catch (err) {
        this.certificates = []
        this.$message.error((err && err.message) || '获取证书失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.my-certificates {
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .section-title {
    font-size: 20px;
    font-weight: 600;
    color: #3E2CCD;
  }
}

.certificates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
  min-height: 120px;
}

.certificate-card {
  border-radius: 8px;
}

.certificate-name {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.certificate-meta {
  .meta-row {
    display: flex;
    align-items: baseline;
    line-height: 22px;
    margin-bottom: 6px;
  }

  .meta-label {
    color: #909399;
    flex: 0 0 auto;
  }

  .meta-value {
    color: #606266;
    word-break: break-all;
  }
}

.no-certificates {
  grid-column: 1 / -1;
}
</style>

